import { inject } from '@angular/core';
import { ConfigStateService, EnvironmentService, LocalizationService, PermissionService } from '@abp/ng.core';

export const injectPermissionChecker = () => inject(PermissionService);
export const injectLocalization = () => inject(LocalizationService);
export const injectConfigState = () => inject(ConfigStateService);
export const injectEnvironment = () => inject(EnvironmentService);
